import React from 'react';
import { useTranslation } from 'react-i18next';

// LA BARRA DE BAIX.
//
// Calcada de la de LUCIFER (`/opt/lucifer/frontend/src/components/Layout.js`), i a posta: les
// aplicacions del servidor són de la mateixa casa i han d'acabar igual per baix. L'única
// diferència és el nom del producte.
//
// Va a **totes** les pantalles, també a la d'entrada i a la de registre —que són fora del
// `Layout`—, perquè és justament allà on algú que encara no té compte es pregunta de qui és
// això que té al davant.
export default function PeuStrategos() {
  const { t } = useTranslation();
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500">
          <div className="mb-1 sm:mb-0">
            © {new Date().getFullYear()} TRAMA. {t('layout.allRightsReserved')}.
          </div>
          <div>
            {t('layout.aProjectOf')}{' '}
            <a href="https://strategos.cat" target="_blank" rel="noopener noreferrer"
              className="font-medium text-gray-700 underline decoration-gray-300 underline-offset-2
                         hover:text-primary-700">
              Strategos.cat
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
